interface TechItem {
  name: string;
  url?: string;
}

interface Category {
  name: string;
  items: TechItem[];
}

const CATEGORIES: Category[] = [
  {
    name: 'AWS Services',
    items: [
      { name: 'S3', url: 'https://aws.amazon.com/s3/' },
      { name: 'CloudFront', url: 'https://aws.amazon.com/cloudfront/' },
      { name: 'API Gateway', url: 'https://aws.amazon.com/api-gateway/' },
      { name: 'Lambda', url: 'https://aws.amazon.com/lambda/' },
      { name: 'DynamoDB', url: 'https://aws.amazon.com/dynamodb/' },
      { name: 'Bedrock', url: 'https://aws.amazon.com/bedrock/' },
      { name: 'CloudWatch', url: 'https://aws.amazon.com/cloudwatch/' },
      { name: 'SNS', url: 'https://aws.amazon.com/sns/' },
      { name: 'X-Ray', url: 'https://aws.amazon.com/xray/' },
      { name: 'IAM', url: 'https://aws.amazon.com/iam/' },
    ],
  },
  {
    name: 'IaC',
    items: [
      { name: 'AWS CDK', url: 'https://aws.amazon.com/cdk/' },
    ],
  },
  {
    name: 'Frontend',
    items: [
      { name: 'React 18', url: 'https://react.dev/' },
      { name: 'Vite', url: 'https://vite.dev/' },
      { name: 'Tailwind CSS', url: 'https://tailwindcss.com/' },
    ],
  },
  {
    name: 'Backend',
    items: [
      { name: 'TypeScript', url: 'https://www.typescriptlang.org/' },
      { name: 'Node.js 22', url: 'https://nodejs.org/' },
      { name: 'Lambda Powertools', url: 'https://docs.powertools.aws.dev/lambda/typescript/latest/' },
      { name: 'esbuild', url: 'https://esbuild.github.io/' },
    ],
  },
  {
    name: 'AI',
    items: [
      { name: 'AWS Bedrock', url: 'https://aws.amazon.com/bedrock/' },
      { name: 'Claude Haiku', url: 'https://www.anthropic.com/claude' },
    ],
  },
  {
    name: 'CI/CD',
    items: [
      { name: 'GitHub Actions', url: 'https://github.com/features/actions' },
      { name: 'OIDC Auth', url: 'https://docs.github.com/en/actions/security-for-github-actions/security-hardening-your-deployments/configuring-openid-connect-in-amazon-web-services' },
    ],
  },
  {
    name: 'Testing',
    items: [
      { name: 'Jest', url: 'https://jestjs.io/' },
      { name: 'CDK Assertions', url: 'https://docs.aws.amazon.com/cdk/api/v2/docs/aws-cdk-lib.assertions-readme.html' },
      { name: 'TDD' },
    ],
  },
  {
    name: 'Methodology',
    items: [
      { name: 'SDD (Tony & Jarvis)', url: 'https://github.com/Gentleman-Programming/gentle-ai' },
      { name: 'DDD' },
      { name: 'TDD' },
      { name: 'AI-Assisted Dev' },
    ],
  },
];

export function TechBadges() {
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {CATEGORIES.map((category) => (
        <div
          key={category.name}
          className="rounded border border-border bg-bg-surface p-4 transition-colors hover:border-accent/30"
        >
          <p className="font-mono text-xs uppercase text-accent tracking-wider mb-3">
            {category.name}
          </p>
          <div className="flex flex-wrap gap-2">
            {category.items.map((item) =>
              item.url ? (
                <a
                  key={item.name}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-full border border-border px-3 py-1 text-xs text-text-primary transition-colors hover:border-accent hover:text-accent"
                >
                  {item.name} ↗
                </a>
              ) : (
                <span
                  key={item.name}
                  className="rounded-full border border-border px-3 py-1 text-xs text-text-primary cursor-default"
                >
                  {item.name}
                </span>
              ),
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
